import { useEffect } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"

import useLoginCookie from "shared/model/useLoginCookie"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

// query로 토큰이 왔을 때, 이를 저장하는 Hook
// 일반 로그인에서는 사용되지 않으며, sns 로그인을 할 때 필요함

// 백엔드에서 sns 로그인에 성공하면, access_token을 query로 "/"로 redirect 시킴
// sns 로그인에 실패하면, message를 query로 "/"로 redirect 시킴

const useSaveToken = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const accessToken = searchParams.get("access_token")
    const message = searchParams.get("message")

    const [, setLoginCookie] = useLoginCookie()
    const [, setAlert] = useAlertModalAtom()

    useEffect(() => {
        if (accessToken) {
            setLoginCookie(accessToken)
            navigate("/", { "replace": true })
        } else if (message) {
            setAlert(message)
            navigate("/", { "replace": true })
        }
    }, [])
}

export default useSaveToken